import { status } from '../constants';
import { StatusType } from '../types/status';

export const getStudyStatus = (statusId: string): StatusType => {
	return (
		status[statusId as keyof typeof status] ?? {
			title: 'Unknown Status',
			content: 'Unknown Status',
		}
	);
};
